export default __webpack_public_path__ + "static/media/learn_illus_flowchart.b31d840f.png";